import axios from "axios";
import { Prices } from "../utils/prices";

const URI = "https://api.gt7.com.br/cdtsite/checkout/services/18";

export async function getPricesCdt(): Promise<Prices> {
  try {
    const { data } = await axios.get(`${URI}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return data;
  } catch (e) {
    return {
      anuidadeTimes: "0",
      clinico_geral: 0,
      dateTime: "",
      demais: 0,
      valor: "0",
    };
  }
}
